import { render } from "./DetalleEmpresa.vue?vue&type=template&id=ae29603a&scoped=true"
import script from "./DetalleEmpresa.vue?vue&type=script&lang=js"
export * from "./DetalleEmpresa.vue?vue&type=script&lang=js"

import "./DetalleEmpresa.vue?vue&type=style&index=0&id=ae29603a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae29603a"]])

export default __exports__